<p-tabView class="block-100">
    <p-tabPanel header="Klassen">
        <div class="flex-row-split height100p">
            <p-tree #tree *ngIf="helpTree != null" class="flex-item-fixed width300 full-height" selectionMode="single" [value]="helpTree.items" [(selection)]="helpTree.selected"
            [filter]=true [filterBy]="'label,data'" (onNodeSelect)="selectClass($event)"></p-tree>
            <div class="flex-item-fill flex-col">
                <div class="mb-2"><span *ngFor="let item of selClassHistory" class="mr-6"><a href="#" (click)="selectClass(null, item); $event.preventDefault()">{{item.getSimpleName()}}</a></span></div>
                <sm-table-on-push *ngIf="fieldsTable != null" class="flex-item-fill height100p full-height" [data]="fieldsTable" (onCellClicked)="fieldCellClicked($event)">
                </sm-table-on-push>
            </div>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Template-Funktionen DHC">
        <sm-table2 *ngIf="functionsDhcTable != null" class="flex-item-fill height100p" [data]="functionsDhcTable">
        </sm-table2>
    </p-tabPanel>
    <p-tabPanel header="Template-Funktionen Scriban">
        <sm-table2 *ngIf="functionsTable != null" class="flex-item-fill height100p" [data]="functionsTable">
        </sm-table2>
    </p-tabPanel>
</p-tabView>
